import React from 'react';
import { Tv } from 'lucide-react';
import { useAuth } from '../App';
import { ClientShell } from './client/ClientShell';
import { ChannelDirectory } from './client/ChannelDirectory';

const Dashboard = () => {
  const { user } = useAuth();

  return (
    <ClientShell>
      <main className="client-workspace" data-testid="client-dashboard">
        <section className="client-player-section" aria-label="Reprodução do canal">
          <div className="client-player-stage client-player-empty" data-testid="client-player-placeholder">
            <Tv aria-hidden="true" />
            <p>Escolha um canal para começar a assistir</p>
          </div>
          <div className="client-welcome" data-testid="client-welcome"><h1>Bem-vindo, {user?.full_name}!</h1></div>
        </section>
        <ChannelDirectory />
      </main>
    </ClientShell>
  );
};

export default Dashboard;